/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect,useRef } from "react";
import { useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import Footer from "../../components/includes/Footer";
import FlyCalling from "../../components/includes/FlyCalling";
import ShowBigSizePhoto from "../../components/popups/ShowBigSizePhoto";

import {isNull,isObjEmpty,LoginAfterCheckLogin,ChangeDateStringOnlyDate,ShowDeliveryStatus,ExecuteDeliveryStatus,
      addThousandPoint,ChangeMobileFormat,ShowColorDeliveryStatus } from "../../components/common/Common";

import "../../css/style.css";

import warningIcon from "../../img/icon/icon-storke-warning.svg";
import receiptIcon from "../../img/icon/icon-stroke-images.svg";

//배차목록호출
const DeliveryDetail = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const { dc_idx } = useParams();
  const navigator = useNavigate();

  //파일선택버튼 
  const fileRef = useRef(null);

  //배차목록
  const [varDeliveryData,setDeliveryData] = useState([]);
  //인수증 사진
  const [varDeliveryPhotos,setDeliveryPhotos] = useState(null);
  //인수증 버튼
  const [varReceiptCertification,setReceiptCertification] = useState(true);
  //인수증결제방법
  const [varReceiptPayment,setReceiptPayment] = useState('없음');

  //배차목록호출
  const GetDeliveryInformation = async () => {
    const sendData = {dc_idx:dc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_delivery_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setDeliveryData(datas.results);
        if(datas.results.dc_receipt_image === 1 && !isNull(datas.results.dc_receipt_file)){
          setReceiptCertification(true);
          setDeliveryPhotos(`${process.env.REACT_APP_HOST}/receipt/${datas.results.dc_receipt_file}`);
        } else if (datas.results.dc_receipt_image === -1) {
          setReceiptCertification(false);
        }
        //인수증결제방법
        if(!isNull(datas.results.dc_receipt_payment)){
          const paymentArray = datas.results.dc_receipt_payment.split(',');
          let soptions = "";
          if(Number(paymentArray[1]) === 1) soptions += " ● 우편 ";
          if(Number(paymentArray[2]) === 1) soptions += " ● 사진 ";
          if(Number(paymentArray[3]) === 1) soptions += " ● 팩스 ";
          if(Number(paymentArray[0]) === 1) soptions += "없음";
          setReceiptPayment(soptions);
        }
      }
    });
  }

  //검색날짜가 변경시
  useEffect(() => {
    GetDeliveryInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dc_idx]);

  //배송상태변경 등록
  const onWorkingProcessHandler = async (e) => {
    const sendData = {dc_idx:dc_idx,dc_status:varDeliveryData.dc_status};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_change_delivery_status`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setDeliveryData(datas.results);
        navigator('/DeliveryState');
      }
    });
  }

  //인수증등록
  const onRegisterReceiptHandler = async (e,imode) => {
    if(imode === 1){
      let formData = new FormData();
      const selectFile = fileRef.current;
      if(!selectFile.value) {
        alert('인수증 이미지 파일을 먼저 선택하세요.');
        return false;
      }  
      formData.append('receipt',selectFile.files[0]);
      if(!window.confirm('선택하신 인수증을 등록합니까?')) return false;

      await axios.post(`${process.env.REACT_APP_HOST}/receipt`, formData).then((res) => {
        if(res.data.retvalue === 1) {
          const sfileName = res.data.fileName;
          UpdateDeliveryReceipt(1,sfileName);
        } else {
          alert('인수증을 서버에 등록할 수 없습니다.');
        }
      });
    } else {
      if(!window.confirm('인수증 없음으로 등록합니까?')) return false;
      setReceiptCertification(false);
      UpdateDeliveryReceipt(-1,'');
    }
  }
  //서버의 데이타베이스 정리
  const UpdateDeliveryReceipt = async(imode,sfileName) => {
    const sendData = {dc_idx:dc_idx,imode:imode,fileName:sfileName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_delivery_receipt`,sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      if(datas.retvalue === 1) navigator('/DeliveryState');
      else alert(res.data.message);
      
    });
  }

  //인수증 이미지 파일
  //사진위치 클릭시 --> 사진선택
  const SelectPhotoHandler = (e) => {
    fileRef.click();
  }
  const onSelectImageBlockHandler = (e) => {
    e.preventDefault();
    onShowBigSizePhotoHandler(e);
  }

  //파일선택되면 --> 미리보기
  const onChangePhotoHandler = (e) => {
    e.preventDefault();
    const uploadFile = e.currentTarget.files[0];
    const previewFile = URL.createObjectURL(uploadFile);
    setDeliveryPhotos(previewFile);
    setDeliveryData({...varDeliveryData,dc_receipt_image:1});
  }
  //파일삭제
  const onDeletePhotoHandler = (e) => {
    setDeliveryPhotos(null);
    setDeliveryData({...varDeliveryData,dc_receipt_image:0});
    UpdateDeliveryReceipt(0,'');
  }

  //사진팝업보기
  const [varOpenPhoto,setOpenPhoto] = useState(false);
  const [varPhotoImage, setPhotoImage] = useState(null);
  const onShowBigSizePhotoHandler = (e) => {
    e.preventDefault();
    setPhotoImage(`${process.env.REACT_APP_HOST}/receipt/${varDeliveryData.dc_receipt_file}`);
    setOpenPhoto(true);
  }
  const onOpenPhotoHandler = (e,bmode) => {
    setOpenPhoto(bmode);
  }

  return isObjEmpty(varDeliveryData)?null:(
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'배차 상세'}/>
        <div className="vh-content-body" style={{marginBottom:"84px"}}>
          <div className="driving-content-wrap">
            <div className="driving-details-wrap">
              <div className="driving-state-bar wait mb25" style={ShowColorDeliveryStatus(varDeliveryData.dc_status)}>{ShowDeliveryStatus(varDeliveryData.dc_status)}</div>
              <div className="driving-title mb20">{varDeliveryData.cs_name}</div>
              <ul className="driving-destination mb10">
                <li>
                  <div className="destination-text">
                    <span className="destination-state">상차</span>
                    <span className="destination-address">{varDeliveryData.dc_riding_address}</span>
                  </div>
                </li>
                {isNull(varDeliveryData.dc_middle_address)?null:
                  <li>
                    <div className="destination-text">
                      <span className="destination-state">경유</span>
                      <span className="destination-address">{varDeliveryData.dc_middle_address}</span>
                    </div>
                  </li>
                }
                <li>
                  <div className="destination-text">
                    <span className="destination-state">하차</span>
                    <span className="destination-address">{varDeliveryData.dc_quit_address}</span>
                  </div>
                </li>
              </ul>
              <div className="driving-info-table">
                <dl>
                  <dt>하차일</dt>
                  <dd>{ChangeDateStringOnlyDate(varDeliveryData.dc_quit_date)}</dd>
                  <dt>운행량</dt>
                  <dd>{varDeliveryData.dc_volume} Km</dd>
                </dl>
                <dl>
                  <dt>상품</dt>
                  <dd>{varDeliveryData.dc_prd_name}</dd>
                  <dt>수량</dt>
                  <dd>{varDeliveryData.dc_prd_quantity}</dd>
                </dl>
                <dl>
                  <dt>요청톤</dt>
                  <dd>{varDeliveryData.dc_prd_req_ton}톤</dd>
                  <dt>전자전표</dt>
                  <dd>{varDeliveryData.dc_prd_slip===0?"없음":"있음"}</dd>
                </dl>
                <dl>
                  <dt>운임료</dt>
                  <dd>{addThousandPoint(varDeliveryData.dc_rprice===0?varDeliveryData.dc_price:varDeliveryData.dc_rprice)} 원</dd>
                  <dt>지급원가</dt>
                  <dd>{addThousandPoint(varDeliveryData.dc_dprice)+" 원"}</dd>
                </dl>
                <dl>
                  <dt>인수증</dt>
                  <dd>{varReceiptPayment}</dd>
                </dl>
                <dl>
                  <dt>배차담당</dt>
                  <dd>
                    <span className="tel-text">{varDeliveryData.mem_name+"("+ChangeMobileFormat(varDeliveryData.mem_mobile)+")"}</span>
                    <a href={`tel:${varDeliveryData.mem_mobile}`} className="tel">전화걸기</a>
                  </dd>
                </dl>
              </div>
              <div className="driving-caution mb30">
                <div className="driving-caution-title">
                  <div className="icon">
                    <img src={warningIcon} alt="" />
                  </div>
                  <span>유의사항</span>
                </div>
                <ul className="driving-caution-desc">
                  <li style={{whiteSpace:"pre-line"}}>{varDeliveryData.dc_prd_notice}</li>
                </ul>
              </div>
              {varDeliveryData.dc_status!==3?null:
                <div className="work-file-upload-wrap mb20">
                  <div className="work-file-title">
                    <div className="icon"><img src={receiptIcon} alt="" /></div>
                    <span>{varReceiptCertification?"인수증 사진":"인수증 없음"}</span>
                  </div>
                  {!varReceiptCertification?null:
                    <div className="work-file-uploader" data-multiple="false">
                      <div className="work-file-uploadInp">
                        <input type="file" ref={fileRef} className="fileInp" accept="image/*" onChange={onChangePhotoHandler}/>
                        {varDeliveryData.dc_receipt_image===0? 
                          <div className="fileOutput" onClick={e=>SelectPhotoHandler(e)}><span>사진선택</span></div>
                        :
                          <div className="fileOutput">
                            <img src={varDeliveryPhotos} onClick={e=>onSelectImageBlockHandler(e)} alt="" />
                            <button className="deleteBtn" onClick={e=>onDeletePhotoHandler(e)}></button>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          {varDeliveryData.dc_status<3?
            <div className="form-contoller flex-horizontal mt-auto">
              <button className="form-contoller-btn" onClick={e=>onWorkingProcessHandler(e)}>{ExecuteDeliveryStatus(varDeliveryData.dc_status)}</button>
            </div>
          :!varReceiptCertification?null:
            <div className="form-contoller flex-horizontal mt-auto">
              <button className="form-contoller-btn btn-white" onClick={e=>onRegisterReceiptHandler(e,-1)}>인수증 없음</button>
              <button className="form-contoller-btn" onClick={e=>onRegisterReceiptHandler(e,1)}>인수증 등록</button>
            </div>
          }
        </div>
        <Footer varActiveMode={2}/>
        <FlyCalling />
      </div>
      {/* 사진확대*/}
      <ShowBigSizePhoto varPhotoImage={varPhotoImage} varOpenPhoto={varOpenPhoto} onOpenPhotoHandler={onOpenPhotoHandler}/>
    </div>
  );
}
export default DeliveryDetail;